import { Injectable } from "@angular/core";

@Injectable()
export class Scheduler {
  schedule(action: () => void, afterMs: number) {
    setTimeout(action, afterMs);
  }
}
